<div class="principal-container">
  <!-- <div class="steps">
    <app-stepper action="auth"></app-stepper>
  </div> -->
  <div class="header-text">
    <p class="title">Inicia sesión o regístrate</p>
    <p class="description">
      Al identificarte estás aceptando nuestras condiciones de uso y venta.
      Consulta nuestro Aviso de Privacidad,

      <br />
      Cookies y Publicidad basada en los intereses del usuario.
      <br />
      <br />

      Si ya tienes una cuenta accede a iniciar sesión, de lo contrario
      regístrate para obtenerla y poder acceder.
    </p>
  </div>
  <div class="auth-container">
    <!-- Inicio flujo login -->
    <div class="login-container">
      <div class="auths-btn">
        <div class="option-auth-login" (click)="getOptionSeleted('login')">
          Iniciar sesión
          <div
            [ngClass]="{ 'line-option-login': this.activeOption === 'login' }"
          ></div>
        </div>

        <div
          class="option-auth-register"
          (click)="getOptionSeleted('register')"
        >
          Registrarse
          <div
            [ngClass]="{
              'line-option-register': this.activeOption === 'register'
            }"
          ></div>
        </div>
      </div>
      <div class="" *ngIf="showLogin">
        <form [formGroup]="loginForm">
          <mat-form-field appearance="legacy" class="email">
            <mat-label>Correo eletrónico</mat-label>
            <mat-icon matPrefix>panorama_fish_eye</mat-icon>
            <input matInput type="text" formControlName="correo_usuario" />
          </mat-form-field>

          <mat-form-field appearance="legacy" class="password">
            <mat-label>Contraseña</mat-label>
            <mat-icon matPrefix>panorama_fish_eye</mat-icon>
            <input matInput type="password" formControlName="clave_usuario" />
          </mat-form-field>
        </form>

        <button
          mat-button
          class="btn btn-login"
          (click)="loginUser(loginForm.value)"
        >
          Iniciar sesión
        </button>
      </div>
    </div>
    <!-- Fin flujo login -->
    <!-- Inicio flujo registro -->
    <div *ngIf="showRegister">
      <div class="register-container">
        <form [formGroup]="registerForm">
          <mat-form-field appearance="legacy" class="names">
            <mat-label>Nombres</mat-label>
            <mat-icon matPrefix>panorama_fish_eye</mat-icon>
            <input matInput type="text" formControlName="nombres_usuario" />
          </mat-form-field>
          <mat-form-field appearance="legacy" class="lastnames">
            <mat-label>Apellidos</mat-label>
            <mat-icon matPrefix>panorama_fish_eye</mat-icon>
            <input matInput type="text" formControlName="apellidos_usuario" />
          </mat-form-field>
          <!-- Fin 2 Campos juntos -->

          <mat-form-field appearance="legacy" class="country">
            <mat-label>País</mat-label>
            <mat-icon matPrefix>panorama_fish_eye</mat-icon>
            <mat-select formControlName="pais_usuario">
              <mat-option value="null">Seleccione un país</mat-option>
              <mat-option *ngFor="let p of paises" [value]="p.name_es">
                {{ p.name_es }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="legacy" class="phone">
            <mat-label>Teléfono</mat-label>
            <mat-icon matPrefix>panorama_fish_eye</mat-icon>
            <input matInput type="tel" formControlName="telefono_usuario" />
          </mat-form-field>
          <mat-form-field appearance="legacy" class="date-of-birth">
            <mat-label>Fecha de nacimiento</mat-label>
            <mat-icon matPrefix>panorama_fish_eye</mat-icon>
            <input
              matInput
              type="date"
              formControlName="fecha_de_nacimiento_usuario"
            />
          </mat-form-field>
          <mat-form-field appearance="legacy" class="email">
            <mat-label>Correo eletrónico</mat-label>
            <mat-icon matPrefix>panorama_fish_eye</mat-icon>
            <input matInput type="text" formControlName="correo_usuario" />
          </mat-form-field>
          <mat-form-field appearance="legacy" class="password">
            <mat-label>Contraseña</mat-label>
            <mat-icon matPrefix>panorama_fish_eye</mat-icon>
            <input matInput type="password" formControlName="clave_usuario" />
          </mat-form-field>
          <mat-form-field appearance="legacy" class="passwordConfirm">
            <mat-label>Confirmar Contraseña</mat-label>
            <mat-icon matPrefix>panorama_fish_eye</mat-icon>
            <input
              matInput
              type="password"
              formControlName="confirmar_clave_usuario"
            />
          </mat-form-field>
          <div class="check-container">
            <p
              class="checkPolitics"
              style="font-family: 'Montserrat' !important;"
            >
              Acepto la política de tratamiento de datos y los términos y
              condiciones de uso
            </p>
            <mat-checkbox formControlName="checkPolitics"></mat-checkbox>
          </div>
        </form>
      </div>
      <button
        (click)="registerUser(registerForm.value)"
        mat-button
        class="btn btn-register"
        [disabled]="!registerForm.valid && !registerForm.value.checkPolitics"
      >
        Crear usuario
      </button>
    </div>
  </div>
</div>
<app-footer></app-footer>
